import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Easing from "react-native-web/dist/exports/Easing";

function makeZoomInTranslation(translationType, pivotPoint) {
  var modifier = Math.min(1, Math.max(-1, pivotPoint));
  return {
    easing: Easing.bezier(0.175, 0.885, 0.32, 1),
    0: _defineProperty({
      opacity: 0,
      scale: 0.1
    }, translationType, modifier * -1000),
    0.6: _defineProperty({
      opacity: 1,
      scale: 0.457
    }, translationType, pivotPoint),
    1: _defineProperty({
      scale: 1
    }, translationType, 0)
  };
}

export var zoomIn = {
  from: {
    opacity: 0,
    scale: 0.3
  },
  0.5: {
    opacity: 1
  },
  to: {
    opacity: 1,
    scale: 1
  }
};

if (typeof zoomIn !== 'undefined' && zoomIn && zoomIn === Object(zoomIn) && Object.isExtensible(zoomIn) && !zoomIn.hasOwnProperty('__filemeta')) {
  Object.defineProperty(zoomIn, '__filemeta', {
    configurable: true,
    value: {
      name: "zoomIn",
      filename: "node_modules/react-native-animatable/definitions/zooming-entrances.js"
    }
  });
}

export var zoomInDown = makeZoomInTranslation('translateY', 60);

if (typeof zoomInDown !== 'undefined' && zoomInDown && zoomInDown === Object(zoomInDown) && Object.isExtensible(zoomInDown) && !zoomInDown.hasOwnProperty('__filemeta')) {
  Object.defineProperty(zoomInDown, '__filemeta', {
    configurable: true,
    value: {
      name: "zoomInDown",
      filename: "node_modules/react-native-animatable/definitions/zooming-entrances.js"
    }
  });
}

export var zoomInUp = makeZoomInTranslation('translateY', -60);

if (typeof zoomInUp !== 'undefined' && zoomInUp && zoomInUp === Object(zoomInUp) && Object.isExtensible(zoomInUp) && !zoomInUp.hasOwnProperty('__filemeta')) {
  Object.defineProperty(zoomInUp, '__filemeta', {
    configurable: true,
    value: {
      name: "zoomInUp",
      filename: "node_modules/react-native-animatable/definitions/zooming-entrances.js"
    }
  });
}

export var zoomInLeft = makeZoomInTranslation('translateX', 10);

if (typeof zoomInLeft !== 'undefined' && zoomInLeft && zoomInLeft === Object(zoomInLeft) && Object.isExtensible(zoomInLeft) && !zoomInLeft.hasOwnProperty('__filemeta')) {
  Object.defineProperty(zoomInLeft, '__filemeta', {
    configurable: true,
    value: {
      name: "zoomInLeft",
      filename: "node_modules/react-native-animatable/definitions/zooming-entrances.js"
    }
  });
}

export var zoomInRight = makeZoomInTranslation('translateX', -10);

if (typeof zoomInRight !== 'undefined' && zoomInRight && zoomInRight === Object(zoomInRight) && Object.isExtensible(zoomInRight) && !zoomInRight.hasOwnProperty('__filemeta')) {
  Object.defineProperty(zoomInRight, '__filemeta', {
    configurable: true,
    value: {
      name: "zoomInRight",
      filename: "node_modules/react-native-animatable/definitions/zooming-entrances.js"
    }
  });
}